import React from 'react';

import Audio from './Audio';
import Video from './Video';
import Embed from './Embed';
import Attachment from './Attachment';

export default (props) => {
  const variant = props.lesson.variant;

  switch (variant) {
    case 'audio':
      return <Audio {...props} />;
    case 'video':
      return <Video {...props} />;
    case 'embed':
      return <Embed {...props} />;
    case 'attachment':
      return <Attachment {...props} />;
    default:
      return null;
  }
};
